import { Coordinates } from './../../interfaces/mechanic/ocr-model';
import { BaseComponent } from './../../common/base-component';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bill',
  templateUrl: './bill.component.html',
  styleUrls: ['./bill.component.scss'],
})
export class BillComponent extends BaseComponent implements OnInit {

  @Input()
  public url: string;
  @Input()
  public coordinates: Coordinates[];
  public dynamicImgId: string;
  public dynamicCanvasId: string;
  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicImgId = this.makeid(10);
    this.dynamicCanvasId = this.makeid(10);
  }

  ngAfterViewInit() {
    this.drawCanvas(this.url, this.dynamicCanvasId, this.coordinates);
  }

  public makeid(length): string {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }
}
